import { Tab, Tabs } from "@mui/material";
import { Form, Formik } from "formik";
import _ from "lodash";
import { useContext, useState } from "react";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import KycApplicationContext from "../../Context/KYCApplicationContext/KYCApplicationContext";
import InitialObjectStructure from "../../FormModel/InitialObjectStructure.json";
import validationSchema from "../../FormModel/validationSchema";
import { EntityTypeEnum } from "../../Store/EntityTypeEnum";
import { getApplicationDTO } from "../../Store/WidgetDataSelector";
import { WidgetEnum } from "../../Store/WidgetEnum";
import { WorkflowTypeEnum } from "../../Store/WorkflowTypeEnum";
import ESignAndTermsAndConditions from "../Widgets/ESignAndTermsAndConditions/ESignAndTermsAndConditions";
import { useWidgetService } from "../Widgets/WidgetManager/UseWidgetService";
//TabPanel Component for display that corresponding tab's content
function TabPanel(props) {
  const { children, value, index } = props;

  return <>{value === index && <>{children}</>}</>;
}
function ESigningTermsAndConditionsForm(props) {
  const { t, i18n } = useTranslation("common");
  const applicationContext = useContext(KycApplicationContext);
  let currentWorkflow = applicationContext.currentWorkflow;
  const [value, setValue] = useState(0);
  const [currentValidationSchema, setCurrentValidationSchema] = useState(
    getFormValidationSchema()
  );
  const {checkFirstHolderHasVideoKYC} = useWidgetService();

  const applicationDTO = useSelector((state) =>
  getApplicationDTO(state)
);
  // get the form validation schema based on the current widget
  function getFormValidationSchema() {
    var widgetValidationSchema = _.find(
      validationSchema,
      (obj) => obj.widgetShortName === WidgetEnum.ESIGNTC
    );

    return widgetValidationSchema.validationSchemaObj;
  }

  // handle submit
  function _handleSubmit(values, actions) {
    props.onSubmit(values).then(
      (res) => {
        // operations to be dont on submit to avoid issues
        actions.setTouched({});
        actions.setSubmitting(false);
      },
      (error) => {
        actions.setSubmitting(false);
      }
    );
  }

  // maintain the current Tab object
  const isActive = (selectedtab) => {
    return (
      " tab_panel_button " +
      (value !== null && value !== undefined && value === selectedtab
        ? "tabactive"
        : "tab_panel_button")
    );
  };

  // assign  selected tab
  const assignTab = (e, obj) => {
    e.preventDefault();

    setValue(obj);
  };

  // tasks to be performed on clicking the back button
  function _handleBack(event, values) {
    event.preventDefault();
    props.onBack(values);
  }

  // tasks to be performed on clicking the next button
  function _handleNext(event) {
    event.preventDefault();
    props.onNext();
  }
  
  
    /**
     *appliction has Single Holder then check workflow if Aadhar then show otherwise not
    *application has Join Holder
    *For First holder always show next
    *For Second Holder check workflow if Aadhar or First holder has video Kyc then show otherwise not
     */
  function showNext(){
    var showNextButton=false;

    if(applicationDTO.kycAccountTypeShortName==='INDI' && currentWorkflow.workflowDisplayName === WorkflowTypeEnum.AADHAAR){
      showNextButton=true;
    }else if(applicationDTO.kycAccountTypeShortName==='JA'){
      if(applicationContext.currentHolder.entityTypeShortName === EntityTypeEnum.FH){     
        showNextButton=true;
      }else if(currentWorkflow.workflowDisplayName === WorkflowTypeEnum.AADHAAR || checkFirstHolderHasVideoKYC()){
          showNextButton=true;        
      } 
    }      
      return showNextButton;
    }
  
  

  return (
    <>
      <Formik
        initialValues={props.value || InitialObjectStructure}
        validationSchema={currentValidationSchema}
        onSubmit={_handleSubmit}
        enableReinitialize={true}
      >
        {({ isSubmitting, errors, values, handleChange }) => (
          <Form id="videoKYCForm" autoComplete="off">
            <Tabs
              variant="scrollable"
              value={value}
              scrollButtons="auto"
              allowScrollButtonsMobile
              className="tab_panel"
            >
              <Tab
                label={t("esign.esignTermsAndConditions")}
                id="tab_panel_button"
                onClick={(event) => assignTab(event, 0)}
                value={0}
                className={isActive(0)}
              ></Tab>
            </Tabs>
            <TabPanel value={value} index={0}>
              <ESignAndTermsAndConditions />
            </TabPanel>
            {errors && console.log(errors)}
            <div className="action_bar d-flex justify-content-between py-2">
              <div>
                {
                  <Button
                    className="btn shadow-none action_btn"
                    onClick={(event) => _handleBack(event, values)}
                  >
                    {" "}
                    {t("form.back")}{" "}
                  </Button>
                }
              </div>
              <div>{ showNext() &&
                <Button
                  className="btn shadow-none action_btn me-2"
                  onClick={(event) => _handleNext(event)}
                  type="submit"
                >
                  {t("form.next")}
                </Button>
              }
              </div>
              
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
}

export default ESigningTermsAndConditionsForm;
